module.exports = __webpack_public_path__ + "static/img/yx.37a329d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx.jpg
// module id = lcBs
// module chunks = 1